<div class="custom-datepicker-card" [ngClass]="'align-' + align">
  <!-- Header Bar -->
  <div class="datepicker-header">
    <button type="button" class="nav-arrow" (click)="prevMonth()" aria-label="Previous Month">&#9664;</button>

    <div class="select-group">
      <select [ngModel]="currentYear" (ngModelChange)="onYearChange($event)" class="picker-select year-select">
        <option *ngFor="let y of years" [value]="y">{{ y }}</option>
      </select>

      <select [ngModel]="currentMonth" (ngModelChange)="onMonthChange($event)" class="picker-select month-select">
        <option *ngFor="let m of months; let idx = index" [value]="idx">{{ m }}</option>
      </select>
    </div>

    <button type="button" class="nav-arrow" (click)="nextMonth()" aria-label="Next Month">&#9654;</button>
  </div>

  <!-- Calendar Body -->
  <div class="datepicker-body">
    <!-- Days of Week Header -->
    <div class="days-header-row">
      <div *ngFor="let dayName of daysOfWeek" class="day-name">{{ dayName }}</div>
    </div>

    <!-- Calendar Grid -->
    <div class="days-grid">
      <div
        *ngFor="let day of calendarDays"
        class="day-cell"
        [class.other-month]="!day.isCurrentMonth"
        [class.selected-day]="day.isSelected"
        (click)="selectDay(day)"
      >
        <span class="day-number">{{ day.date }}</span>
      </div>
    </div>
  </div>

  <!-- Footer Controls -->
  <div class="datepicker-footer">
    <button type="button" class="footer-btn today-btn" (click)="selectToday()">
      <span class="footer-icon icon-blue">&#9660;</span> Today
    </button>
    <button type="button" class="footer-btn clear-btn" (click)="clearDate()">
      <span class="footer-icon icon-red">&#8722;</span> Clear
    </button>
    <button type="button" class="footer-btn close-btn" (click)="close()">
      <span class="footer-icon icon-dark">&#10005;</span> Close
    </button>
  </div>
</div>
